import { handleImageFormat } from "./format";
var DefaultQuality = 80;
var FormatDefaultQuality = new Map([['webp', 80], ['avif', 60]]);
export function handleImageQuality(quality, format) {
  // 指定quality
  if (typeof quality === 'number') {
    // 合法
    if (quality > 0 && quality <= 100) return quality;
    // 不合法
    console.warn("quality should be larger than 0 and less than or equal to 100, but got ".concat(quality));
  }

  // 最终决定的格式转换类型
  var result_format = handleImageFormat(format);

  // 未进行格式转换，不需要quality
  if (!result_format) return undefined;

  // 取默认值
  return FormatDefaultQuality.get(result_format) || DefaultQuality;
}